const Pencil = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.773 2.585a2.283 2.283 0 0 0-3.229 0L2.77 13.361a2.284 2.284 0 0 0-.625 1.166l-.447 2.235a1.522 1.522 0 0 0 1.792 1.79l2.234-.446a2.282 2.282 0 0 0 1.166-.624L17.665 6.706a2.283 2.283 0 0 0 0-3.229l-.892-.892ZM14.62 3.662a.761.761 0 0 1 1.077 0l.892.891a.761.761 0 0 1 0 1.077l-2.034 2.033-1.968-1.968 2.033-2.033Zm-3.11 3.11-7.665 7.665a.761.761 0 0 0-.208.39L3.19 17.06l2.234-.447a.762.762 0 0 0 .39-.208l7.665-7.665L11.51 6.77Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Pencil;
